import { useBooking } from "@/context/BookingContext";
import { IMAGES } from "@/lib/images";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import PaymentLogos from "@/components/PaymentLogos";

export default function Hero() {
  const { openBooking } = useBooking();

  return (
    <section id="home" data-testid="hero" className="relative min-h-screen bg-[#FAF8F5] overflow-hidden flex items-end">
      <div className="absolute inset-0">
        <img src={IMAGES.heroEye} alt="Editorial lash close-up" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917]/85 via-[#1C1917]/25 to-[#1C1917]/30" />
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-[#FAF8F5] to-transparent" />
      </div>

      <div className="relative w-full max-w-[1400px] mx-auto px-5 sm:px-10 pb-24 sm:pb-28 pt-32">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="flex items-center gap-4 mb-7"
        >
          <span className="w-10 h-px bg-[#C5B382]" />
          <span className="text-[#C5B382] text-[10px] sm:text-[11px] tracking-[0.35em] uppercase">Custom Lash Extensions</span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-white text-[20vw] sm:text-[15vw] lg:text-[12rem] font-medium leading-[0.85] tracking-tight"
        >
          Lashes<br />made<br /><span className="italic text-[#C5B382]">for you.</span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.3 }}
          className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4"
        >
          <button
            data-testid="hero-book"
            onClick={() => openBooking()}
            className="group inline-flex items-center justify-center gap-3 bg-[#C5B382] hover:bg-white text-[#1C1917] text-[11px] font-semibold tracking-[0.2em] uppercase px-8 py-4 rounded-full transition-colors duration-300"
          >
            Book Now
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            href="#work"
            data-testid="hero-explore"
            className="inline-flex items-center justify-center gap-3 text-white/90 hover:text-white text-[11px] font-medium tracking-[0.2em] uppercase px-8 py-4 rounded-full border border-white/30 hover:border-white transition-colors duration-300"
          >
            Explore the Work
          </a>
        </motion.div>

        <div className="mt-10 flex flex-wrap items-center gap-x-5 gap-y-3">
          <span className="text-white/50 text-[10px] tracking-[0.35em] uppercase">Moonee Ponds · Melbourne</span>
          <PaymentLogos data-testid="hero-stripe" />
        </div>
      </div>
    </section>
  );
}
